import { configureStore } from "@reduxjs/toolkit";
import countryReducer from './slice/countrySlice';
import authReducer from './slice/authSlice';

export const store = configureStore({
  reducer: {
    country: countryReducer,
    auth: authReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
